import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'
import { localize } from 'helpers/translator/localize'
import currentViewSelector from 'redux/selectors/ui/currentViewSelector'
import tooltipsSelector from 'redux/selectors/tooltips/tooltips_selector'
import topInformationTypes from 'helpers/enums/topInformationTypes'

const topInformationSelector = state => state.topInformation.array
const topInformationGameSelector = state => state.game.topInformation
const topInformationCreationToolMcqSelector = state => state.creationTool.mcq.topInformation
const topInformationInteractiveVideoSelector = state => state.interactiveVideo.topInformation
const getCurrentView = state => currentViewSelector(state)
const getTooltips = state => tooltipsSelector(state)

export default createSelector(
	[
		topInformationSelector,
		topInformationGameSelector,
		topInformationCreationToolMcqSelector,
		topInformationInteractiveVideoSelector,
		getCurrentView,
		getTooltips,
	],
	(
		topInformationMessages,
		gameMessages,
		creationToolMcqMessages,
		interactiveVideoSelector,
		currentView,
		tooltipsData,
	) => {
		let message
		if (topInformationMessages.length) {
			message = topInformationMessages[0]
		} else if (gameMessages.length) {
			message = gameMessages[0]
		} else if (creationToolMcqMessages.length) {
			message = creationToolMcqMessages[0]
		} else if (interactiveVideoSelector.length) {
			message = interactiveVideoSelector[0]
		} else if (
			currentView === viewTypes.GOOGLE_SLIDES_SIDEBAR
			&& tooltipsData.tooltips.tooltipGSCannotCopyAndPasteSlides
		) {
			message = {
				message: localize('googleSlides_copyPasteTooltip_text'),
				styleType: 'neutral',
				showCloseBtn: true,
				uid: topInformationTypes.GOOGLE_SLIDES_CANNOT_COPY_PASTE_SLIDES,
			}
		}
		return {
			topInformation: message,
		}
	}
)
